export default __webpack_public_path__ + "static/media/logokarma.24e0debe.svg";